import React, { useEffect, useContext, useSyncExternalStore } from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import { isAdSafeContent } from "~utils/ads/adLogic";
import { CurrentStoryContext } from "~utils/currentStoryContext";

import styles from "./styles.module.css";

type BrandMetricsProps = {
    className?: string;
};

trackBrandMetricsAnswers();
let shouldRenderBrandMetricsSurvey = true;
const listeners: Array<() => void> = [];

const dispatchBrandMetricsTargetVisibilityChange = (
    newShouldRenderBrandMetricsSurveyValue: boolean
) => {
    shouldRenderBrandMetricsSurvey = newShouldRenderBrandMetricsSurveyValue;

    for (const listener of listeners) {
        if (typeof listener === "function") {
            listener();
        } else {
            console.error(
                `Type of listener "${listener}" is not a valid listener`
            );
        }
    }
};

export const useIsBrandMetricsSurveyRenderer = () =>
    useSyncExternalStore(
        (subscriber) => {
            listeners.push(subscriber);
            return () => listeners.filter((l) => l !== subscriber);
        },
        () => shouldRenderBrandMetricsSurvey,
        () => false
    );

const BrandMetrics = (props: BrandMetricsProps) => {
    const { className } = props;
    const brandMetricsClasses = createClasses([
        styles.brandmetricsContainer,
        className,
    ]);
    useEffect(() => {
        window._brandmetrics = window._brandmetrics || [];
        window._brandmetrics.push({ cmd: "_loadsurvey" });

        window._brandmetrics.push({
            cmd: "_querysurvey",
            val: {
                callback(
                    surveyAvailable: boolean,
                    _conf: object,
                    _survey: object
                ) {
                    if (!surveyAvailable) {
                        dispatchBrandMetricsTargetVisibilityChange(false);
                    }
                },
            },
        });
    }, []);

    return (
        <>
            <div id="brandmetrics-survey" className={brandMetricsClasses} />
        </>
    );
};

const BrandMetricsModule = (props: BrandMetricsProps) => {
    const { story } = useContext(CurrentStoryContext);

    const isSafe = story.contentTags
        ? isAdSafeContent(story.contentTags)
        : true;

    return isSafe && <BrandMetrics {...props} />;
};

export default BrandMetricsModule;

export function trackBrandMetricsAnswers() {
    if (typeof window === "undefined") return;

    window._brandmetrics = window._brandmetrics || [];
    window._brandmetrics.push({
        cmd: "_addeventlistener",
        val: {
            event: "surveyanswered",
            handler: (ev) => {
                try {
                    ev.answers.split(";").forEach((questionAnswers: string) => {
                        const [question, answers] = questionAnswers.split("-");
                        window.dataLayer?.push({
                            event: "brandmetrics_survey_answered",
                            eventCategory: ev.mid,
                            eventAction: question,
                            eventLabel: answers,
                        });
                    });
                } catch (e) {
                    console.error(
                        "Error pushing Brand Metrics survey answers",
                        e
                    );
                }
            },
        },
    });
}
